module.exports = __webpack_public_path__ + "img/login-min.dddb8082.png";